module.exports = "/assets/data/08a367f2fd177751301e2258e20aa012-TS5.data.json";